import React, { useEffect, useState, useRef } from 'react';
import { useFormik } from 'formik';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { isAdminRole, statusOptions } from '../../../utils/mics';
import appActions from '../../../appActions';
import SiteGroupForm from './SiteGroupForm';
import { InputText } from 'primereact/inputtext';
import ExportExcel from '../../../components/ExportExcel';
import ImportExcel from '../../../components/ImportExcel';
const SiteGroupFilterBar = (props) => {

    const dispatch = useDispatch();

    const siteGroup = useSelector((state) => state.sitegroup.siteGroupDetails);

    const siteGroupList = useSelector((state) => state.sitegroup.siteGroupList);

    const { userInfo } = props;
    const { userRole } = userInfo;

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (siteGroup?.id) {
            setVisible(false);
            dispatch(appActions.SITEGROUP_RESET_SUCCESS());
        }
    }, [siteGroup]);

    const formik = useFormik({

        initialValues: {
            siteCode: '',
            siteName:'',
            status: ''
        },
        enableReinitialize: true,
        onSubmit: (values) => {
            const data = {
                ...values,
            };
            const params = data;
            Object.keys(params).forEach((key) => {
                if (params[key] === '') {
                    delete params[key];
                }
            });
            props.handleFilter(params);
        },
        
    });

    const handleReset = () => {
        formik.resetForm();
    };

    const isEmpty = (obj) => {
        return Object.keys(obj).length === 0;
    };

    return (
        <>
            <Dialog
                header="Create a new site group"
                visible={visible}
                style={{ width: '60vw' }}
                onHide={() => setVisible(false)}
            >
                <SiteGroupForm />
            </Dialog>

            <div className="flex mb-4 align-items-end">
                <form onSubmit={formik.handleSubmit}>
                    <div className="flex flex-wrap align-items-end gap-10 pb-0">
                        {/* Form Fields */}

                        <div className="form-group">
                            <label htmlFor="siteCode" className="flex align-items-center"> Site Group Code </label>
                            <InputText
                                className="w-full"
                                id="siteCode"
                                value={formik.values.siteCode}
                                onChange={formik.handleChange}
                                placeholder="Site Group Code"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="siteName" className="flex align-items-center"> Site Group Name </label>
                            <InputText
                                className="w-full"
                                id="siteName"
                                value={formik.values.siteName}
                                onChange={formik.handleChange}
                                placeholder="Site Group Name"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="status" className="flex align-items-center"> Status </label>
                            <Dropdown
                                className="w-full"
                                id="status"
                                value={formik.values.status}
                                options={statusOptions}
                                optionLabel="name"
                                optionValue='code'
                                onChange={(e) => formik.setFieldValue('status', e.value)}
                                placeholder="Status"
                            />
                        </div>

                        {/* Buttons */}
                        <Button
                            type="submit"
                            icon="pi pi-search"
                            severity="basic"
                        />
                        {!isEmpty(props.filterParams) && (
                            <Button
                                onClick={handleReset}
                                icon="pi pi-times"
                                severity="secondary"
                                aria-label="Cancel"
                            />
                        )}
                    </div>
                </form>
                {isAdminRole(userRole) && (
                    <div className='flex justify-content-end ml-auto gap-10' style={{ minWidth: '200px' }}>

                        <ExportExcel fileName={'site_group_management'} rowData={siteGroupList?.data} /> 

                        <ImportExcel url={'sitegroup/uploadFile'}
                                    handleSearch={props.handleSearch}/>

                        <Button
                            icon="pi pi-plus"
                            label="Add"
                            severity="basic"
                            onClick={() => setVisible(true)}
                        />
                    </div>
                )}
            </div>
        </>
    );
};

export default SiteGroupFilterBar;
